import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Icon } from ".."
// import { Badge } from '@material-ui/core'
import { NOTIFICATION_TYPES } from "../../data"

const useStyles = makeStyles((theme) => ({
  normal: {
    backgroundColor: "#efefef",
    borderRadius: "4px",
    color: "black",
    padding: "3px !important",
  },
  unconfirmed: {
    backgroundColor: theme.palette.secondary.main,
    color: "white",
    borderRadius: "4px",
    padding: "3px !important",
  },
}))

const NotificationIcon = ({ hasConfirm, confirmed, type }) => {
  const classes = useStyles()

  const className = (hasConfirm && confirmed) || !hasConfirm ? classes.normal : classes.unconfirmed

  switch (type) {
    case NOTIFICATION_TYPES.PROCESS:
      return <Icon name="process" className={className} />
    case NOTIFICATION_TYPES.TASK:
      return <Icon name="task" className={className} />
    case NOTIFICATION_TYPES.KNOWLEDGE:
      return <Icon name="knowledge" className={className} />
    case NOTIFICATION_TYPES.POST:
      return <Icon name="post" className={className} />
    case NOTIFICATION_TYPES.ACTION:
      return <Icon name="action" className={className} />
    case NOTIFICATION_TYPES.TRAINING:
      return <Icon name="training" className={className} />
    case NOTIFICATION_TYPES.ACCREDITATION:
      return <Icon name="accreditation-alt" className={className} />
    default:
      return <Icon name="notifications" className={className} />
  }
}

export default NotificationIcon
